module.exports = __webpack_public_path__ + "img/fi-rr-flame.eb4f3ee9.svg";